export default __webpack_public_path__ + "static/media/biryani.cdd9b6f2.jpeg";